module.exports = __webpack_public_path__ + "img/liquidfeedback.png";